import Axios from 'axios';

import { applyInterceptors } from '../../../lib/PST.Web.Common/src/services/api/xhr';
import { logError } from '../../../lib/PST.Web.Common/src/services/error/actions';

const initXHR = (store) => {
    const errorLogger = logError(store);

    applyInterceptors((error) => {
        if (!Axios.isCancel(error)) {
            errorLogger(error);
        }
    });
};

export { initXHR };
